import { render, staticRenderFns } from "./QuestionRadio.vue?vue&type=template&id=5f52d3fe&"
import script from "./QuestionRadio.vue?vue&type=script&lang=js&"
export * from "./QuestionRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports